<div class="flex gap-2 justify-end">
  <a
    panButton
    [routerLink]="['/home', 'manage', 'branch', params.branchId(), 'location', params.data.id]"
    [queryParams]="{ subpage: 'change-history' }"
    icon="history"
  >
    History
  </a>

  <a panButton icon="edit" color="info" [routerLink]="['/home', 'manage', 'branch', params.branchId(), 'location', params.data.id]"></a>
</div>
